import $ from 'jquery';
$(function () {
    const forgotPassword = $("#ForgotPassword");
    if (forgotPassword.length === 0) return;

    forgotPassword.on("click", function (e) { 
        e.preventDefault();
        const radios = document.getElementsByName('IsPractice');
        let isAnySelected = false;

        for (let i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
                isAnySelected = true;
                break;  
            }
        }
         
        const errorDisplay = document.getElementById('errorMessage');

        if (!isAnySelected && errorDisplay.classList.contains('hide')) { 
            errorDisplay.classList.remove('hide'); 
            return;
        } 
        if (isAnySelected){ 
            errorDisplay.classList.add('hide'); 
        } 

        const userNameInput = $("#UserName");
        let isPracticeValue = document.getElementById('Practice')?.checked || false;
        const userNameValue = userNameInput.val().trim();
       
        if(userNameValue==='') {
            const validationSpan = userNameInput.next('span.text-danger');
            validationSpan.text("Username or Email is required."); 
            userNameInput.addClass("field-validation-error");
            validationSpan.removeClass("field-validation-valid").addClass("field-validation-error");

            return false;
        }
       
        userNameInput.next('span.text-danger').text("");
        userNameInput.removeClass("field-validation-error");
     
        if(errorDisplay.classList.contains('hide')) 
        {
            $.ajax({
                url: `/Account/ForgotPassword?memberNumber=${userNameValue}&isPractice=${isPracticeValue}`,
                type: "POST",
                success: function (response) {
                    if (response.success && response.redirectUrl) { 
                        window.location.href = response.redirectUrl; 
                    }
                }
            });
        }
        
    });
});
